export const SET_CHAPTERS = 'SET_CHAPTERS';
export const SET_CHAPTER = 'SET_CHAPTER';
export const SET_SYNC_FOR_CURRENT_CHAPTER = 'SET_SYNC_FOR_CURRENT_CHAPTER';
export const UPDATE_SYNC_FOR_CURRENT_CHAPTER = 'UPDATE_SYNC_FOR_CURRENT_CHAPTER';
export const DELETE_SYNC_FOR_CURRENT_CHAPTER = 'DELETE_SYNC_FOR_CURRENT_CHAPTER';
export const ADD_CHAPTER = 'ADD_CHAPTER';
export const DELETE_CHAPTER = 'DELETE_CHAPTER';
export const SET_ARTISTS = 'SET_ARTISTS';

